<!-- <div class="transaction-manager-dialog"> -->
<mat-toolbar class="mat-elevation-z8">
  Skapa transaktion för Order Nr: {{order.orderNr}}
</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="transactionForm" (ngSubmit)="onSubmit()">
    <div class="form-container">

      <div class="form-row">
        <!-- Extra Days -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Pris för extradagar inkl. moms</mat-label>
          <input matInput formControlName="extraDays" placeholder="Pris för extradagar inkl. moms">
        </mat-form-field>
        <!-- Insurance Cost -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Försäkringskostnad</mat-label>
          <input matInput formControlName="insuranceCost" placeholder="Försäkringskostnad">
        </mat-form-field>

      </div>

      <h1 class="mb-2">Additional Services</h1>

      <!-- Additional Services -->
      @if (remainingServices.length > 0) {
        <div class="services-section">
          <h4 class="mb-2">Available Services</h4>
          <mat-selection-list class="border">
            @for (service of remainingServices; track service) {
              <mat-list-option [value]="service"
                (click)="onServiceSelectionChange($event, service)">
                <div class="service-item">
                  <div class="service-name">{{ service.name | translateAttribute }}</div>
                  <div class="service-price">
                    {{ service.totalPrice | currency:'SEK ':'symbol':'1.2-2' }}
                  </div>
                </div>
              </mat-list-option>
            }
          </mat-selection-list>
          @if (orderAdditionalServices && orderAdditionalServices.length > 0) {
            <h4 class="mt-2 mb-2">Selected Services</h4>
          }
          @if (orderAdditionalServices && orderAdditionalServices.length > 0) {
            <div class="p-2 border">
              @for (service of orderAdditionalServices; track service) {
                <div class="p-2">
                  <div class="service-item">
                    <div class="service-name">{{ service.name | translateAttribute }}</div>
                    <div class="service-price">
                      {{ service.totalPrice | currency:'SEK ':'symbol':'1.2-2' }}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (remainingServices.length === 0) {
        <div class="no-services">
          <p>No additional services available to add.</p>
        </div>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onCancel()" [disabled]="isSubmitting">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="transactionForm.invalid || isSubmitting"
    [class.spinner]="isSubmitting">
    {{ isSubmitting ? 'Processing...' : 'Save Transaction' }}
  </button>
</mat-dialog-actions>
<!-- </div> -->
